import React, { useEffect, useState } from 'react'
import { Button, Col, Container, Form, Modal, Row, Table, Badge } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import "../../../node_modules/react-datepicker/dist/react-datepicker.css";
import Loginheader from '../Loginheader';
import Menu from '../Menu';
import * as Common from '../Common';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faFileDownload, faInfoCircle, faDownload } from '@fortawesome/free-solid-svg-icons';
import Dialog from '../Dialog';
import $ from "jquery";
import { faTrashAlt } from '@fortawesome/free-regular-svg-icons';




const SpecialApproval = () => {

    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);
    const [entityType, setEntityType] = useState(sessionStorage.entityType);
    const [entityId, setEntityId] = useState(sessionStorage.entityId);

    const [srno, setSrno] = useState('');
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const [splStatus, setSplStatus] = useState('P');
    const [splLimit, setSplLimit] = useState('50');

    const [splRef, setSplRef] = useState('');
    const [splAmt, setSplAmt] = useState('');
    const [splDate, setSplDate] = useState(new Date());

    const [scrMode, setScrMode] = useState('');

    const [viewSrno, setViewSrno] = useState('');
    const [viewRefNo, setViewRefNo] = useState('');
    const [viewLan, setViewLan] = useState('');
    const [viewTTRefNo, setViewTTRefNo] = useState('');
    const [viewDate, setViewDate] = useState('');
    const [viewAmt, setViewAmt] = useState('');
    const [viewStatus, setViewStatus] = useState('');
    const [viewProductCode, setViewProductCode] = useState('');

    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");

    const [splApprovalData, setSplApprovalData] = useState([]);
    var msg = [], i = 0;

    const [srchRef, setSrchRef] = useState("");
    const [ddReqPayBankOptions, setDdReqPayBankOptions] = useState([]);
    const [reqPayBankCode, setReqBankCode] = useState("0");
    const [reqPayBankName, setReqBankName] = useState("");

    const [innerSplApproval, setInnerSplApproval] = useState([]);

    const [docListData, setDocListData] = useState([]);

    const [documentToView, setDocumentToView] = useState("");
    const [documentTypeToView, setDocumentTypeToView] = useState("");
    const [documentDescToView, setDocumentDescToView] = useState("");
    const [documentNameToView, setDocumentNameToView] = useState("");
    const [showDocument, setShowDocument] = useState(false);
    const [isClickedUpload, setIsClickedUpload] = useState(false);
    const [spclApprovalFile, setSpclApprovalFile] = useState("");
    const [specialUploadRight, setSpecialUploadRight] = useState([]);

    const [reqAgent, setReqAgent] = useState("0");
    const [ddReqAgentOptions, setDdReqAgentOptions] = useState([]);
    const [reqAgentName, setReqAgentName] = useState("");


    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'SPECIALAPPROVAL'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    return;
                } else {
                    navigate('/'); // no query right
                }
            });
            Common.callApi(Common.apiRight, [sid, 'all', 'SPECIALAPPROVALUPLOAD'], (result) => {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setSpecialUploadRight(resp);
                }
            });
            if (sessionStorage.entityType === "A") {
                setDdReqAgentOptions([{ label: sessionStorage.entityname, value: sessionStorage.entityId }]);
                onChangeAgent(sessionStorage.entityId, sessionStorage.entityname);
            }
            if (sessionStorage.entityType === "B") {
                Common.callApi(Common.apiEntity, [sid, 'ddlistjsonagentselect'], function (result) {
                    let resp = JSON.parse(result);
                    setDdReqAgentOptions(resp);
                });
            }
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);

    const showList = () => {
        setSplApprovalData([]);
        $(".loader").show();

        if ((!srno && !fromDate && splStatus === 'D') || (!srno && !toDate)) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = ((!srno && !fromDate && splStatus === 'D') ? 'From Date' : '');
            msg[i++] = ((!srno && !toDate) ? 'to Date' : '');

            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            const obj = {
                srchRef: srchRef,
                fromDate: Common.dateYMD(fromDate),
                toDate: Common.dateYMD(toDate),
                status: splStatus,
                limit: splLimit,
                reqAgent: reqAgent,
            }
            console.log("Agent code is :", reqAgent);
            Common.callApi(Common.apiSpecialApproval, [sid, 'specialapprovallist', JSON.stringify(obj)], (result) => {
                let resp = JSON.parse(result);
                setSplApprovalData(resp);
                $(".loader").hide();
            })
        }

    }

    const btnView = (id, ref, amt, date, brnno, status, refno, lan, productCode) => {
        $(".loader").show();
        setScrMode('V');
        setViewSrno(id);
        setViewRefNo(ref);
        setViewLan(lan);
        setViewDate(date);
        setViewAmt(amt);
        setViewStatus(status);
        setViewTTRefNo(refno);
        setViewProductCode(productCode);
        $(".loader").hide();

        Common.callApi(Common.apiBank, [sid, 'ddlistjsonbranchwise', brnno], function (result3) {
            setDdReqPayBankOptions(JSON.parse(result3));
        });

        const obj = {
            srno: id
        }

        Common.callApi(Common.apiSpecialApproval, [sid, 'innerspecialapproval', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            console.log(resp);
            setInnerSplApproval(resp);
            $(".loader").hide();
        });

        Common.callApi(Common.apiSpecialApproval, [sid, 'specialapprovaldoc', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            console.log(resp);
            setDocListData(resp);
            $(".loader").hide();
            // });
            // if (entityType === "A" && entityId === "13") {
            //     setReqBankCode("1");
            //     setReqBankName("AVANSE BANK ACCOUNT");
            // }
        });
        if (entityType === "A" && entityId === "13") {
            setReqBankCode("60");
            setReqBankName("HDFC 99990011091970");
        }
    }



    const btnUpdateSplData = () => {
        $(".loader").show();

        if (!splRef || !splAmt || !splDate || reqPayBankCode == '0') {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (reqPayBankCode == '0' ? 'Bank' : '');
            msg[i++] = (!splRef ? 'Ref No.' : '');
            msg[i++] = (!splDate ? 'Date' : '');
            msg[i++] = (!splAmt ? 'Amount' : '');

            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
            $(".loader").hide();
        }
        else {
            const obj = {
                viewAmt: viewAmt,
                srno: viewSrno,
                bank: reqPayBankCode,
                splRef: splRef,
                splAmt: splAmt,
                splDate: Common.dateYMD(splDate),
                fromDate: Common.dateYMD(fromDate),
                toDate: Common.dateYMD(toDate),
                status: splStatus
            }
            Common.callApi(Common.apiSpecialApproval, [sid, 'updatespecialapproval', JSON.stringify(obj)], (result) => {
                let resp = JSON.parse(result);
                console.log(resp);
                setInnerSplApproval(resp.resarray);
                setViewStatus(resp.status);
                setMsgText(resp.msg);
                setMsgBox(true);
                setSplRef('');
                setSplAmt('');
                setReqBankCode('0');
                setSplDate(new Date());
                $(".loader").hide();
            })
        }
    }

    const btnBack = () => {
        setScrMode('');
        showList();
    }

    function showSearchOptions() {
        setMsgText("Search on : Serial Number, Reference Number, PAN, Remitter Name");
        setMsgBox(true);
    }

    function handleReqPayBank(v, t) {
        console.log(v);
        console.log(t);
        setReqBankCode(v);
        setReqBankName(t);
    }

    function btnDocumentDownload(srno, filename) {
        $(".loader").show();
        var object1 = {
            srno: srno,
            filename: filename
        }
        Common.callDownloadApiPost(Common.apiSpecialApproval, "post", [sid, 'docdownload', JSON.stringify(object1)]);
        $(".loader").hide();
    }


    function btnDocumentView(srno, filename) {
        $('.loader').show();
        var object1 = {
            srno: srno,
            filename: filename
        }
        Common.callDocumentViewApi(Common.apiSpecialApproval, [sid, 'docview', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            $('.loader').hide();
            setDocumentToView(resp.bs64);
            setDocumentTypeToView(resp.typ);
            setDocumentDescToView(resp.desc);
            setDocumentNameToView(resp.fname);
            setShowDocument(true);
        });
    }

    function btnDeleteDocumentClick(srno, docid, filename) {
        var object1 = {
            srno: srno,
            filename: filename,
            docid: docid
        }
        Common.callApi(Common.apiSpecialApproval, [sid, 'docremove', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            if (resp.error === "") {
                alert(resp.message);
            } else {
                alert(resp.error);
            }
            setDocListData(resp.docdetail);
        });
    }


    function isBankBlocked() {
        if (entityType === "A" && entityId === "13") {
            return true;
        } else {
            return false;
        }
    }


    const handleDownload = () => {
        $('.loader').show();
        const obj = {
            srchRef: srchRef,
            fromDate: Common.dateYMD(fromDate),
            toDate: Common.dateYMD(toDate),
            status: splStatus,
            limit: splLimit,
            reqAgent: reqAgent
        }
        Common.callDownloadApiPost1(Common.apiSpecialApproval, "post", [sid, 'downloadSpclExcel', JSON.stringify(obj)], (result) => {
            $('.loader').hide();
        });
    }

    const handleUpload = () => {
        setIsClickedUpload(true);
    }

    const uploadFile = () => {
        $('.loader').show();
        if (spclApprovalFile === "") {
            $('.loader').hide();
            setMsgText("Please Select a File to Upload.");
            setMsgBox(true);
        } else {
            $('.loader').show();
            var tempArray = document.getElementById('fileToUpload').files[0].name.split('.');

            if (tempArray.length > 2) {
                $('.loader').hide();
                setMsgText("(.) not allowed in file name.");
                setMsgBox(true);
            } else if (document.getElementById('fileToUpload').files[0] === undefined) {
                $('.loader').hide();
                setMsgText("Please select a file to upload.");
                setMsgBox(true);
            } else if (document.getElementById('fileToUpload').files[0].size > 10 * 1024 * 1024) {  // 10 MB
                $('.loader').hide();
                setMsgText("Please select a file with in 10 MB size.");
                setMsgBox(true);
            } else {
                var object1 = {
                    sid: sid,
                    uploadType: 'SPECIALAPPROVAL',
                    srno: 0,
                    pageright: 'SPECIALAPPROVAL',
                    docid: 0,
                }

                Common.uploadApi(JSON.stringify(object1), 'fileToUpload', function (result) {
                    $('.loader').hide();
                    console.log(result);
                    let resp = JSON.parse(result);

                    if (resp.error === "") {
                        alert(resp.message);
                        setInnerSplApproval(resp.docdetail);
                    } else {
                        alert(resp.error);
                    }
                    setIsClickedUpload(false);
                    setSpclApprovalFile("");
                });
            }
        }
    }

    // const handleDownloadBadge = () => {
    //     var obj = {
    //         right: 'SPECIALAPPROVAL',
    //     }
    //     Common.callDownloadApiPost(Common.apiReport, "post", [sid, JSON.stringify(obj)]);
    // }

    function handleDownloadBadge() {
        $('.loader').show();
        var object1 = {
            srno: 23
        }
        Common.callDownloadApiPost1(Common.apiFormat, "post", [sid, 'specialApproval', JSON.stringify(object1)], (result) => {
            $('.loader').hide();
        });
    }

    function onChangeAgent(id, agnname) {
        setReqAgent(id);
        setReqAgentName(agnname);
    }



    const getMimeType = (ext) => {
        switch (ext.toLowerCase()) {
            case "pdf":
                return "application/pdf";
            case "jpg":
            case "jpeg":
                return "image/jpeg";
            case "png":
                return "image/png";
            case "webp":
                return "image/webp";
            default:
                return "application/octet-stream";
        }
    };

    const openDocument = (resp) => {
        setDocumentToView(resp.url_path);
        setDocumentTypeToView(getMimeType(resp.doc_ext));
        setDocumentDescToView(resp.docm_desc);
        setDocumentNameToView(resp.doc_aws_path);
        setShowDocument(true);
    };

    return (
        <div>
            <Loginheader></Loginheader>
            <Menu></Menu>

            <Container fluid>
                <Row>
                    <Col>
                        <h2>Special Approval</h2>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                {
                    scrMode === '' ?
                        <>
                            <Row>
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Search...<span className="handCursor colorThemeBlue" title="Help"
                                            onClick={(e) => showSearchOptions()}><FontAwesomeIcon icon={faInfoCircle} />
                                        </span></Form.Label>
                                        <Form.Control type="text" placeholder="Search..."
                                            maxLength={50} autoComplete="off"
                                            value={srchRef}
                                            onChange={(e) => Common.validateAlpNumSplValue(e.target.value, setSrchRef)}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Status </Form.Label>
                                        <Form.Select
                                            value={splStatus}
                                            onChange={(e) => setSplStatus(e.target.value)} >
                                            <option value="D">Done</option>
                                            <option value="P">Pending</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Agent<span className="mandatory">*</span></Form.Label>
                                        <Form.Select
                                            value={reqAgent}
                                            onChange={(e) => onChangeAgent(e.target.value, e.target[e.target.selectedIndex].text)}
                                            disabled={entityType === 'A'} >
                                            {ddReqAgentOptions.map((res) =>
                                                <option key={res.value} value={res.value}>{res.label}</option>
                                            )}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col className='col-md-3 col-6'>&nbsp;</Col>
                                {
                                    srchRef.length == 0 ?
                                        <>
                                            {
                                                splStatus === 'D' &&
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group >
                                                        <Form.Label>From Date</Form.Label>
                                                        <DatePicker className="form-control"
                                                            selected={fromDate}
                                                            onChange={(date) => setFromDate(date)}
                                                            isClearable
                                                            dateFormat="dd/MM/yyyy"
                                                            showYearDropdown
                                                            showMonthDropdown
                                                            useShortMonthInDropdown
                                                            placeholderText='From Date'
                                                            dropdownMode="select"
                                                            peekNextMonth
                                                            customInput={
                                                                <input type="text" onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)} ></input>
                                                            }
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            }

                                            <Col className='col-md-3 col-6'>
                                                <Form.Group >
                                                    <Form.Label>To Date</Form.Label>
                                                    <DatePicker className="form-control"
                                                        selected={toDate}
                                                        onChange={(date) => setToDate(date)}
                                                        isClearable
                                                        dateFormat="dd/MM/yyyy"
                                                        showYearDropdown
                                                        showMonthDropdown
                                                        useShortMonthInDropdown
                                                        placeholderText='To Date'
                                                        dropdownMode="select"
                                                        peekNextMonth
                                                        customInput={
                                                            <input type="text" onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)} ></input>
                                                        }
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>Limit </Form.Label>
                                                    <Form.Select
                                                        value={splLimit}
                                                        onChange={(e) => setSplLimit(e.target.value)} >
                                                        <option value="50">50</option>
                                                        <option value="100">100</option>
                                                        <option value="ALL">ALL</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>

                                        </> : <>
                                            <Col>&nbsp;</Col>
                                            <Col>&nbsp;</Col>
                                        </>
                                }
                                <Col>&nbsp;</Col>
                            </Row> &nbsp;
                            <Row>
                                <Col>
                                    <Button variant="outline-primary" size="sm" onClick={() => showList()}>List</Button>&nbsp;
                                    <Button variant="outline-success" size="sm" onClick={() => handleDownload()}>Download</Button>&nbsp;
                                    {
                                        (!isClickedUpload && (specialUploadRight.query === "1")) && <Button variant="outline-success" size="sm" onClick={() => handleUpload()}>Upload</Button>
                                    }
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            {
                                isClickedUpload &&
                                <>
                                    <Row>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group controlId="fileToUpload">
                                                <Form.Label>Choose File<span className="text-danger">*</span></Form.Label>
                                                <Form.Control type="file" value={spclApprovalFile} onChange={(e) => setSpclApprovalFile(e.target.value)} />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>&nbsp;</Row>
                                    <Row>
                                        <span>
                                            <Badge bg="secondary" className="handCursor" onClick={handleDownloadBadge}>Download <FontAwesomeIcon icon={faDownload} /></Badge>
                                        </span><br></br>
                                        <Col><Button variant="outline-success" className='buttonStyle' size='sm' onClick={() => uploadFile()}>Submit</Button>{' '}</Col>
                                    </Row>
                                </>
                            }
                            <Row>&nbsp;</Row>
                            {
                                splApprovalData.length > 0 &&
                                <Row>
                                    <Col>
                                        <Table responsive striped bordered>
                                            <thead>
                                                <tr>
                                                    <th>Request Ref No.</th>
                                                    {
                                                        entityType === "B" ? <th>Comment</th> : null
                                                    }

                                                    <th>LAN</th>
                                                    <th>Product</th>
                                                    <th>Amount</th>
                                                    <th>Date</th>
                                                    <th>PAN</th>
                                                    <th>Agent Name</th>
                                                    <th>Remitter Name</th>
                                                    <th>Status</th>
                                                    <td>&nbsp;</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    splApprovalData.map((item, index) => (
                                                        <tr key={item.pay_srno}>
                                                            <td>{item.req_refno}</td>
                                                            {
                                                                entityType === "B" ? <td>{item.pay_refno}</td> : null
                                                            }

                                                            <td>{item.req_loanaccountno}</td>
                                                            <td>{item.req_productcode}</td>
                                                            <td>{item.pay_amnt}</td>
                                                            <td>{item.formatted_date}</td>
                                                            <td>{item.req_pan}</td>
                                                            <td>{item.entity_name}</td>
                                                            <td>{item.req_remittername}</td>
                                                            <td>{item.pay_spcl_status === 'D' ? 'Done' : 'Pending'}</td>
                                                            <td>
                                                                <div className="colorThemeBlue">
                                                                    <span className="handCursor" onClick={(e) => btnView(item.pay_srno, item.pay_refno, item.pay_amnt, item.formatted_date, item.req_brnno, item.pay_spcl_status, item.req_refno, item.req_loanaccountno, item.req_productcode)}>
                                                                        <FontAwesomeIcon icon={faEye} />
                                                                    </span>&nbsp;
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </Table>
                                    </Col>
                                </Row>
                            }
                        </> : <>
                            <Row>
                                <Col>
                                    <Button variant="outline-primary" size="sm" onClick={() => btnBack()}>Back</Button>&nbsp;
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Col>
                                    <Form.Group >
                                        <Form.Label><b>Ref No</b> : {viewTTRefNo}</Form.Label>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group >
                                        <Form.Label><b>LAN</b> : {viewLan}</Form.Label>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group >
                                        <Form.Label><b>Date</b> : {viewDate}</Form.Label>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group >
                                        <Form.Label><b>Amount</b> : {viewAmt}</Form.Label>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group >
                                        <Form.Label><b>Status</b> : {viewStatus === 'D' ? 'Done' : 'Pending'}</Form.Label>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Group >
                                        <Form.Label><b>Product</b> : {viewProductCode === "CNCARD" ? "CN/CARD" : viewProductCode}</Form.Label>
                                    </Form.Group>
                                </Col>
                                {
                                    entityType === "B" ? <>
                                        <Col>
                                            <Form.Group >
                                                <Form.Label><b>Comment</b> : {viewRefNo}</Form.Label>
                                            </Form.Group>
                                        </Col>
                                    </> : null
                                }
                            </Row>



                            <Row>&nbsp;</Row>
                            {viewStatus !== 'D' &&
                                <>
                                    <Row>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label>Bank<span className="colorThemeRed">*</span></Form.Label>
                                                <Form.Select
                                                    value={reqPayBankCode}
                                                    onChange={(e) => handleReqPayBank(e.target.value, e.target.options[e.target.selectedIndex].text)}
                                                    disabled={isBankBlocked()}
                                                >
                                                    {ddReqPayBankOptions.map((res) =>
                                                        <option key={res.value} value={res.value}>{res.name}</option>
                                                    )}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>

                                        <Col>
                                            <Form.Group >
                                                <Form.Label>Ref No.<span className="colorThemeRed">*</span></Form.Label>
                                                <Form.Control type="text" placeholder="Ref No." maxLength={50}
                                                    onChange={(e) => Common.validateAlpNumSplValue(e.target.value, setSplRef)}
                                                    value={splRef} autoComplete="off" />
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group >
                                                <Form.Label>Date<span className="colorThemeRed">*</span></Form.Label>
                                                <DatePicker className="form-control"
                                                    selected={splDate}
                                                    onChange={(date) => setSplDate(date)}
                                                    isClearable
                                                    dateFormat="dd/MM/yyyy"
                                                    showYearDropdown
                                                    showMonthDropdown
                                                    useShortMonthInDropdown
                                                    placeholderText='Date'
                                                    dropdownMode="select"
                                                    peekNextMonth
                                                    customInput={
                                                        <input type="text" onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)} ></input>
                                                    }
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group >
                                                <Form.Label>Amount<span className="colorThemeRed">*</span></Form.Label>
                                                <Form.Control type="text" placeholder="Amount" maxLength={20}
                                                    onChange={(e) => Common.validateDecValue(e.target.value, setSplAmt)}
                                                    value={splAmt} autoComplete="off" />
                                            </Form.Group>
                                        </Col>
                                        <Col>&nbsp;</Col>
                                    </Row>
                                    <Row>&nbsp;</Row>
                                    <Row>
                                        <Col>
                                            <Button variant="outline-primary" size="sm" onClick={() => btnUpdateSplData()}>Add</Button>&nbsp;
                                        </Col>
                                    </Row>
                                </>
                            }
                            {
                                innerSplApproval.length > 0 &&

                                <Row>
                                    <Col>
                                        <Table responsive striped bordered>
                                            <thead>
                                                <tr>
                                                    <th>Bank</th>
                                                    <th>Ref No.</th>
                                                    <th>Amount</th>
                                                    <th>Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    innerSplApproval.map((item, index) => (
                                                        <tr key={item.pay_spcl_srno}>
                                                            <td>{item.bank_name}</td>
                                                            <td>{item.pay_spcl_refno}</td>
                                                            <td>{item.pay_spcl_amnt}</td>
                                                            <td>{item.formatted_date}</td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </Table>
                                    </Col>
                                </Row>

                            }
                            <Row>&nbsp;</Row>
                            <Row>
                                <Col>
                                    <h5>Documents</h5>
                                </Col>
                            </Row>

                            {
                                docListData.length > 0 ?
                                    <>
                                        <Row>
                                            <Col>
                                                <Table responsive striped bordered hover>
                                                    <thead>
                                                        <tr>
                                                            <td>Type</td>
                                                            <td>Remark</td>
                                                            <td>File Name</td>
                                                             <td>Upload Timestamp</td>
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            docListData.filter(res => res.doc_id > 997).map((res, index) => (
                                                                <tr key={res.doc_filename}>
                                                                    <td className='divHide'>{res.doc_srno}</td>
                                                                    <td>{res.doc_id + ' : ' + res.docm_desc}</td>
                                                                    <td>{res.doc_remark}</td>
                                                                    <td>{res.doc_aws == 1 ? res.doc_aws_path.slice(10) : res.doc_filename}</td>
                                                                     <td>{res.doc_uploadedat}</td>
                                                                    <td>
                                                                        <div className="colorThemeBlue">
                                                                            {
                                                                                (res.doc_aws != 1 && (res.doc_ext === "pdf" || res.doc_ext === "jpeg" || res.doc_ext === "gif"
                                                                                    || res.doc_ext === "jpg" || res.doc_ext === "png")) ? <>
                                                                                    <span className="handCursor" onClick={(e) => btnDocumentView(res.doc_srno, res.doc_filename)}>
                                                                                        <FontAwesomeIcon icon={faEye} />
                                                                                    </span>&nbsp;
                                                                                </> : null
                                                                            }


                                                                            {(res.doc_aws == 1 &&
                                                                                (
                                                                                    res.doc_ext === "pdf" ||
                                                                                    res.doc_ext === "jpeg" ||
                                                                                    res.doc_ext === "gif" ||
                                                                                    res.doc_ext === "jpg" ||
                                                                                    res.doc_ext === "png" ||
                                                                                    res.doc_ext === "webp"
                                                                                )) && (
                                                                                    <span
                                                                                        onClick={() => Common.viewUploadedDocument(res.doc_aws_path, sid, openDocument)}
                                                                                        className="pointer colorThemeBlue"
                                                                                    >
                                                                                        <FontAwesomeIcon icon={faEye} />
                                                                                    </span>
                                                                            )}

                                                                            
                                                                            &nbsp;&nbsp;
                                                                            {res.doc_aws == 1 ? (
                                                                                <span className="handCursor" onClick={() => Common.downloadUploadedDocument(res.doc_aws_path, sid)}>
                                                                                    <FontAwesomeIcon icon={faFileDownload} />
                        
                                                                                </span>
                                                                            ) :

                                                                            <span className="handCursor" onClick={(e) => btnDocumentDownload(res.doc_srno, res.doc_filename)}>
                                                                                <FontAwesomeIcon icon={faFileDownload} />
                                                                            </span>
                                                                            }
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        }
                                                    </tbody>
                                                </Table>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                Swift Password : 33325360
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Table responsive striped bordered hover>
                                                <tbody>
                                                    {
                                                        docListData.filter(res => res.doc_id < 998).map((res, index) => (
                                                            <tr key={res.doc_filename}>
                                                                <td className='divHide'>{res.doc_srno}</td>
                                                                <td>{res.doc_id + ' : ' + res.docm_desc}</td>
                                                                <td>{res.doc_remark}</td>
                                                                <td>{res.doc_aws == 1 ? res.doc_aws_path.slice(10) : res.doc_filename}</td>

                                                                 <td>{res.doc_uploadedat}</td>
                                                                <td>
                                                                    <div className="colorThemeBlue">
                                                                        {
                                                                           (res.doc_aws != 1 && (res.doc_ext === "pdf" || res.doc_ext === "jpeg" || res.doc_ext === "gif"
                                                                                || res.doc_ext === "jpg" || res.doc_ext === "png") )? <>
                                                                                <span className="handCursor" onClick={(e) => btnDocumentView(res.doc_srno, res.doc_filename)}>
                                                                                    <FontAwesomeIcon icon={faEye} />
                                                                                </span>&nbsp;
                                                                            </> : null
                                                                        }
                                                                            

                                                                            {(res.doc_aws == 1 &&
                                                                            (
                                                                                res.doc_ext === "pdf" ||
                                                                                res.doc_ext === "jpeg" ||
                                                                                res.doc_ext === "gif" ||
                                                                                res.doc_ext === "jpg" ||
                                                                                res.doc_ext === "png" ||
                                                                                res.doc_ext === "webp"
                                                                            )) && (
                                                                                <span
                                                                                    onClick={() => Common.viewUploadedDocument(res.doc_aws_path, sid, openDocument)}
                                                                                    className="pointer colorThemeBlue"
                                                                                >
                                                                                    <FontAwesomeIcon icon={faEye} />
                                                                                </span>
                                                                            )}
                                                                              &nbsp;&nbsp;
                                                                            {res.doc_aws == 1 ? (
                                                                                <span className="handCursor" onClick={() => Common.downloadUploadedDocument(res.doc_aws_path, sid)}>
                                                                                    <FontAwesomeIcon icon={faFileDownload} />
                        
                                                                                </span>
                                                                            ) :

                                                                            <span className="handCursor" onClick={(e) => btnDocumentDownload(res.doc_srno, res.doc_filename)}>
                                                                                <FontAwesomeIcon icon={faFileDownload} />
                                                                            </span>

                                                                            }
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    }
                                                </tbody>
                                            </Table>
                                        </Row>
                                    </>


                                    :
                                    <Row>
                                        <Col>
                                            <h6>Documents not available</h6>
                                        </Col>
                                    </Row>
                            }


                        </>
                }
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>

                <Modal
                    show={showDocument}
                    onHide={() => setShowDocument(false)}
                    size="xl"
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="example-custom-modal-styling-title">
                            {documentDescToView + " : " + documentNameToView}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <embed src={documentToView} type={documentTypeToView} style={{ minHeight: "100vh", minWidth: "100%" }} ></embed>
                        {
                            /*
                            type="image/png" type="application/pdf"
                            width="100%" height="100%"
                            
                            <object data={documentToView} type={documentTypeToView} class="internal">
         
                            </object>
                            */
                        }
                    </Modal.Body>
                </Modal>

            </Container>

            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>

        </div>
    )
}

export default SpecialApproval